exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-fluid[_v-da65e614]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-da65e614&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/About/Carousel.vue
// module id = 463
// module chunks = 0